const rules = {
	email: /^[!#$%&'*+/=?^_`{|}~a-z0-9-.]+@[a-zA-Z0-9._-]+\.+[a-z._-]+$/i
};

export default function (rule, value, extra) {
	let valid;
	switch (rule) {
		case "email":
			valid = rules[rule].test(value);
			if (valid) {
				const [local, domain] = value.split("@");
				if (
					local.startsWith(".") ||
					local.endsWith(".") ||
					/\.{2,}/.test(local) ||
					/^(-|\.|_)/.test(domain) ||
					/(-|\.|_)$/.test(domain)
				) {
					valid = false;
				}
			}
			break;
		case "regexp":
			const { pattern, flags = "i" } = extra;
			valid = false;
			const regex = new RegExp(pattern, flags);
			if (regex.test(value)) {
				valid = true;
			}
			break;
		default:
			valid = false;
	}
	return valid;
}
